export type ElComponentSize = 'tiny' | 'small' | 'medium' | 'large' | 'giant';
